import { formatDate, ukNow } from "@/helpers/dateHelper";
import timetableService from "@/services/timetable.service";
import { addMonths, startOfMonth } from "date-fns";
import { zonedTimeToUtc } from 'date-fns-tz';
import { computed, ref } from "vue";

const maxMonths = ref(12);
const useTimetableMonth = () => {

    timetableService.getMaxMonth().then(m => maxMonths.value = (m ?? 12)).catch(() => maxMonths.value = 12);

    const getMonthOptions = (max: number) => {
        const now = ukNow();
        const currentMonth = zonedTimeToUtc(startOfMonth(now), 'Europe/London');
        
        const options = [
            {
                label: formatDate(currentMonth, "MMMM yyyy"),
                value: formatDate(currentMonth, 'yyyy-MM-dd'),
            },
        ];
        
        let counter = 0;
        while (counter < max) {
            counter++;
            const newMonth = addMonths(currentMonth, counter);
            options.push({
                label: formatDate(newMonth, "MMMM yyyy"),
                value: formatDate(newMonth, 'yyyy-MM-dd'),
            });
        }

        return options;
    };

    const monthOptions = computed(() => {
        return getMonthOptions(maxMonths.value);
    });

    return {
        monthOptions
    }
}

export default useTimetableMonth;